import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getDocumentbyId } from './api_project';

const initialState = null;

export const fetchDocumentData = createAsyncThunk(
  'ui/fetchDocumentData',
  async (obj, thunkAPI) => {
    const { getState } = thunkAPI;
    const response = await getDocumentbyId(obj);
    return response.data;
  }
);

const projectSingleDocSlice = createSlice({
  name: 'documentById',
  initialState,
  reducers: {
    resetDocumentReducer: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDocumentData.pending, (state) => {
        return {
          ...state,
          status: 'loading',
          documentsLoaded: false,
          documentsFetchFailed: false,
          document: initialState,
        };
      })
      .addCase(fetchDocumentData.fulfilled, (state, action) => {
        return {
          ...state,
          status: 'idle',
          document: action.payload,
          documentsFetchFailed: false,
          documentsLoaded: true,
        };
      })
      .addCase(fetchDocumentData.rejected, (state) => {
        return {
          ...state,
          documentsFetchFailed: true,
          status: 'idle',
          documentsLoaded: true,
        };
      });
  },
});

export const getProjectDocById = (state) => state.documentById?.document;

export const { resetDocumentReducer } = projectSingleDocSlice.actions;
export default projectSingleDocSlice.reducer;
